import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
interface AboutProps {
  language: 'en' | 'es';
}
export function About({
  language
}: AboutProps) {
  const t = {
    en: {
      eyebrow: 'ABOUT BLACKSTONE RENTALS',
      heading: 'Your Neighbors. Your Rental Company.',
      p1: "We're not a national chain or an out-of-state call center. Blackstone Rentals LLC was built right here in West Texas to serve the oilfield workers, contractors, families, and ranchers of this community.",
      p2: 'We started this company because we saw how poorly local businesses were being served by unreliable rental companies. Late deliveries, dirty units, and no communication. We decided to do it differently.',
      p3: "When you rent from us, you can count on clean equipment, honest pricing, and service that reflects the values of West Texas. That's the Blackstone Standard.",
      serving: 'Serving Odessa, Midland, Andrews, Pecos, Fort Stockton & surrounding areas'
    },
    es: {
      eyebrow: 'SOBRE BLACKSTONE RENTALS',
      heading: 'Tus Vecinos. Tu Empresa de Rentas.',
      p1: 'No somos una cadena nacional ni un centro de llamadas fuera del estado. Blackstone Rentals LLC fue construida aquí mismo en West Texas para servir a los trabajadores petroleros, contratistas, familias y rancheros de esta comunidad.',
      p2: 'Empezamos esta empresa porque vimos lo mal que las empresas locales eran atendidas por compañías de renta poco confiables. Entregas tardías, unidades sucias y sin comunicación. Decidimos hacerlo diferente.',
      p3: 'Cuando rentas con nosotros, puedes contar con equipo limpio, precios honestos y un servicio que refleja los valores de West Texas. Ese es el Estándar Blackstone.',
      serving: 'Sirviendo Odessa, Midland, Andrews, Pecos, Fort Stockton y áreas circundantes'
    }
  };
  const text = t[language];
  return <section id="about" className="py-12 md:py-20 bg-obsidian border-t border-steel w-full overflow-hidden" data-id="element-29">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <div className="max-w-3xl mx-auto" data-id="element-31">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center" data-id="element-32">
            <span className="font-montserrat text-gold text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-33">
              {text.eyebrow}
            </span>
            <h2 className="font-oswald text-3xl sm:text-4xl md:text-5xl font-bold text-warmWhite uppercase mb-4 md:mb-6" data-id="element-34">
              {text.heading}
            </h2>
            <div className="space-y-4 md:space-y-5 font-inter text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-35">
              <p data-id="element-36">{text.p1}</p>
              <p data-id="element-37">{text.p2}</p>
              <p className="font-bold text-warmWhite" data-id="element-38">{text.p3}</p>

              <div className="pt-4 flex items-center justify-center gap-3 bg-carbon p-4 rounded-lg border border-steel mt-6 max-w-lg mx-auto" data-id="element-39">
                <MapPin size={24} color="#C9952A" className="flex-shrink-0" data-id="element-40" />
                <p className="text-sm font-medium text-warmWhite text-left" data-id="element-41">
                  {text.serving}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}